<template>
  <el-dialog
    :fullscreen="isMobile"
    :visible.sync="isVisible"
    custom-class="publish-article-popup"
    width="38%"
    center
    destroy-on-close
    append-to-body
  >
    <div slot="title" class="text-left">
      <b>{{ $t("SELECT_PUBLISH_DATE") }}</b>
    </div>
    <div :class="{ mobile: isMobile }">
      <el-form 
        ref="publishForm"
        :model="formData"
        :rules="rules"
      >
        <el-form-item
          :label="$t('PUBLISH_DATE')"
          prop="publishDate"
          class="is-required"
        >
        <!-- Disable past dates -->
          <el-date-picker
            class="w-100"
            v-model="formData.publishDate"
            :size="isMobile ? 'mini' : null"
            placement="bottom-start"
            prefix-icon="custom-icon icon-calendar mini"
            :format="isMobile ? EL_DATE_FORMAT_MOBILE : EL_DATE_FORMAT"
            value-format="timestamp"
            @focus="e => e.blur()"
            :picker-options="{
              disabledDate: date => date.getTime() < Date.now() - 8.64e7
            }"
          />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" class="w-25 btn-cancel">{{
        $t("CANCEL")
      }}</el-button>
      <el-button class="button primary" @click="handleSubmit">{{ $t("PROCEED") }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { generalMixin } from "@/utils/general-mixin.js";

/**
 * @component PublishArticleDialog
 * @description Dialog component for selecting a publish date for an article
 */
export default {
  name: 'PublishArticleDialog',
  mixins: [generalMixin],
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    handlePublish: {
      type: Function,
      required: true,
      validator: (value) => typeof value === 'function'
    },
  },
  data() {
    return {
      formData: {
        publishDate: Date.now()
      },
      rules: {
        publishDate: [
          { required: true, message: this.$t('PUBLISH_DATE_REQUIRED'), trigger: 'change' }
        ]
      }
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {    
    closeDialog() {
      this.isVisible = false;
    },
    
    validateForm() {
      return new Promise(resolve => {
        this.$refs.publishForm.validate(valid => {
          resolve(valid);
        });
      });
    },
    
    processSubmission() {
      this.handlePublish(this.formData.publishDate);
      this.closeDialog();
    },
    
    handleFormError(error) {
      console.error('Error during publish form processing:', error);
      this.$notify({
        type: 'error',
        message: this.$t('An error occurred. Please try again.'),
        duration: this.NOTIFY_DURATION,
        position: this.NOTIFY_POSITION
      });
    },
    
    async handleSubmit() {
      try {
        const isValid = await this.validateForm();
        
        if (isValid) {
          this.processSubmission();
        }
      } catch (error) {
        this.handleFormError(error);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
/* Dialog styling for article publishing */
.publish-article-popup {
  border-radius: 5px;
  .el-dialog__header {
    border-bottom: 1px solid #c7c7c77d;
  }
  .el-dialog__footer {
    border-top: 1px solid #c7c7c77d;
  }
  .el-dialog__body {
    padding: 1rem 1rem 0;
    word-break: break-word;
    color: #767396;
  }
  .btn-cancel {
    color: #a8a8a8;
  }
}
</style>
